import clsx from 'clsx';

interface DottedBorderSideProps {
  side: 'top' | 'right' | 'bottom' | 'left';
  overhang?: number;
  color?: string;
  opacity?:
    | 'opacity-0'
    | 'opacity-5'
    | 'opacity-10'
    | 'opacity-20'
    | 'opacity-25'
    | 'opacity-30'
    | 'opacity-40'
    | 'opacity-50'
    | 'opacity-60'
    | 'opacity-70'
    | 'opacity-75'
    | 'opacity-80'
    | 'opacity-90'
    | 'opacity-95'
    | 'opacity-100';
}

export function DottedBorderSide({
  side,
  overhang = 32,
  color = '%23212126', // Default color if none is given
  opacity = 'opacity-20' // Default opacity if none is given
}: DottedBorderSideProps) {
  const margin = `${overhang / -16}rem`;
  const maskImage = `linear-gradient(to ${
    side === 'top' || side === 'bottom' ? 'right' : 'bottom'
  }, transparent, white ${overhang / 16}rem, white calc(100% - ${
    overhang / 16
  }rem), transparent)`;

  return (
    <div
      className={clsx(
        `${opacity} absolute`,
        side === 'top' || side === 'bottom'
          ? 'inset-x-0 h-px'
          : 'inset-y-0 w-px',
        side === 'top' && '-top-px',
        side === 'right' && '-right-px',
        side === 'bottom' && '-bottom-px',
        side === 'left' && '-left-px'
      )}
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${
          side === 'top' || side === 'bottom' ? '4 1' : '1 4'
        }'%3E%3Crect width='1' height='1' fill='${color}'/%3E%3C/svg%3E")`,
        WebkitMaskImage: maskImage,
        maskImage,
        ...(side === 'top' || side === 'bottom'
          ? { marginLeft: margin, marginRight: margin }
          : { marginTop: margin, marginBottom: margin })
      }}
    />
  );
}

interface DottedBorderProps {
  overhang?: number;
  color?: string;
}

export function DottedBorder({ overhang, color }: DottedBorderProps) {
  return (
    <>
      <DottedBorderSide side="top" overhang={overhang} color={color} />
      <DottedBorderSide side="right" overhang={overhang} color={color} />
      <DottedBorderSide side="bottom" overhang={overhang} color={color} />
      <DottedBorderSide side="left" overhang={overhang} color={color} />
    </>
  );
}
